import { Modal } from "rizzui";
import { PiXBold } from "react-icons/pi";
import SpamDetectionCard from "@/components/SpamDetectionCard";
import { ContactSaleSubmissionReport } from "@/utilities/types/EnquiryEntry";
import convertToSingaporeTime from "@/utilities/functions/convertToSingaporeTime";

interface SpamDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  reportData?: ContactSaleSubmissionReport;
}

export default function SpamDetailsModal({
  isOpen,
  onClose,
  reportData,
}: SpamDetailsModalProps) {
  if (!reportData) return null;

  // Format the data for display
  const flaggedBy = [
    ...(reportData.emails?.length ? ["Email Address"] : []),
    ...(reportData.phones?.length ? ["Phone Number"] : []),
  ].join(" + ");

  const knownAlias = reportData.alias?.join(", ") || "N/A";
  const reportedOn = convertToSingaporeTime(
    new Date(reportData.createdAt),
    "DD MMMM YYYY • hh:mmA"
  );
  const lastSeen = convertToSingaporeTime(
    new Date(reportData.lastSubmissionAt),
    "DD MMMM YYYY • hh:mmA"
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" className="z-[99999]">
      <div className="relative">
        <button
          onClick={onClose}
          className="p-1 hover:bg-gray-100 rounded-full transition-colors absolute top-3 right-3"
        >
          <PiXBold className="h-5 w-5 text-gray-500" />
        </button>

        <SpamDetectionCard
          title="FraudDetect • Spam"
          flaggedBy={flaggedBy}
          knownAlias={knownAlias}
          modusOperandi={reportData.description}
          lastSeen={lastSeen}
          reportedOn={reportedOn}
          reportId={reportData.reportID}
        />
      </div>
    </Modal>
  );
}
